import { createSelector } from "reselect";
export const selActionItems= state => state.ActionItems.filter(ai=>!ai.deleted);
export const selActionItemsByPlantID=createSelector(selActionItems,(_,plantID)=>plantID,
    (actionItems,plantID)=>{
        return actionItems.filter(ai=>ai.plantID===plantID);
    }
);